// TabsOrAccordion.js
import React, { useState, useEffect } from "react";

const TabsOrAccordion = ({ tabAtiva, setTabAtiva, conteudoTabs }) => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const abasDisponiveis = Object.entries(conteudoTabs).filter(([_, value]) => !!value);

  if (isMobile) {
    return (
      <div className="accordion mt-4" id="accordionMedicamento">
        {abasDisponiveis.map(([key, value]) => (
          <div className="accordion-item" key={key}>
            <h2 className="accordion-header" id={`heading-${key}`}>
              <button
                className={`accordion-button ${tabAtiva === key ? "" : "collapsed"}`}
                type="button"
                onClick={() => setTabAtiva(tabAtiva === key ? null : key)}
                data-bs-toggle="collapse"
                data-bs-target={`#collapse-${key}`}
              >
                {value.label}
              </button>
            </h2>
            <div
              id={`collapse-${key}`}
              className={`accordion-collapse collapse ${tabAtiva === key ? "show" : ""}`}
              data-bs-parent="#accordionMedicamento"
            >
              <div className="accordion-body">{value.component}</div>
            </div>
          </div>
        ))}
      </div>
    );
  }

  return (
    <>
      <ul className="nav nav-tabs mt-4">
        {abasDisponiveis.map(([key, value]) => (
          <li className="nav-item" key={key}>
            <button
              className={`nav-link ${tabAtiva === key ? "active" : ""}`}
              onClick={() => setTabAtiva(key)}
            >
              {value.label}
            </button>
          </li>
        ))}
      </ul>
      <div className="tab-content border p-3">
        {tabAtiva && conteudoTabs[tabAtiva]?.component}
      </div>
    </>
  );
};

export default TabsOrAccordion;
